// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-formbuilder {
  display: grid;
  grid-template-columns: 1fr 5fr;
  height: 100vh;
}

.left-sidebar {
  text-align: center;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
}

.middle-sidebar {
  overflow: hidden;
  overflow-y: auto;
  padding: 25px;
  padding-bottom: 35px;
}

.form-container {
  width: 90%;
  margin: 0 auto;
}

.right-sidebar {
  background-color: #d4d4d4;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
}

.type-box {
  border: solid 2px black;
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
  cursor: pointer;
  background-color: grey;
  color: white;
}

.main-container {
  width: 70%;
  margin: 0 auto;
  height: 100vh;
  margin-top: 20px;
  padding: 40px;
}

.schema-container {
  width: 80%;
  margin: 0 auto;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  margin-top: 40px;
  padding: 20px;
}

.drop-zone {
  border: 2px dotted #b0b0b0;
  padding: 10px;
  min-height: 200px;
}

.drop-zone.withfield {
  border: none;
}

.drop-zone-text {
  position: absolute;
  font-size: 20px;
  font-weight: 600;
  color: #b0b0b0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.drag-over {
  border: 2px dotted #b0b0b0;
  background-color: #dfdfdf;
}

.drag-zone {
  height: 100% !important;
}

.droppable-list {
  padding: 10px;
  margin: 10px;
  cursor: pointer;
  color: black;
}

.draggable-list-item {
  border: 2px solid #b0b0b0;
  padding: 10px;
  margin: 10px;
  cursor: pointer;
  background-color: grey;
  color: white;
}

.layout-drop-zone {
  border: 2px dotted #b0b0b0;
  padding: 10px;
}

.fb-sidebar {
  background-color: #fcfcfd;
  width: 250px;
}

.sticky-sidebar {
  position: sticky;
  top: 70px;
  z-index: 1000;
}

.simplebar-content {
  height: 100vh;
}

.form-name:disabled {
  background-color: #fff;
}

.fb-btn {
  background-color: #fff;
  color: #344054;
  border: 1px solid lightgray;
  padding: 8px 15px 8px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);
  font-weight: 500;
}

.fb-btn:hover,
.fb-btn:active {
  background-color: #0a56ae;
  color: #fff;
}

.fb-save-btn {
  background-color: #12a35d;
  color: #fff;
  padding: 8px 15px 8px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);
  font-weight: 500;
}

.fb-delete-btn {
  background-color: #d90909;
  color: #fff;
  padding: 8px 15px 8px 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);
  font-weight: 500;
}

.fb-delete-btn:hover {
  background-color: #fff;
  border: 1px solid #d90909;
  color: #d90909;
}

.form-info-label {
  font-weight: 300;
}

.empty-dnd-box {
  position: absolute;
  top: 80px;
  left: 30%;
}

.dnd-text {
  font-weight: 100;
  font-size: 15px;
  text-align: center;
}

.dnd-box {
  border-width: 1px;
  border-style: dashed;
  border-color: #b0b0b0;
  border-radius: 8px;
  padding: 5px;
  min-height: 200px;
}

@media (min-width: 1024px) {
  .simplebar-content {
    height: 85vh;
  }

  .form-info-label {
    font-size: 11px;
  }
}
@media (min-width: 1920px) {
  .form-info-label {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/components/formbuilder/FormBuilder.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;AACF;;AAEA;EAEE,kBAAA;EAEA,aAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;EACA,gBAAA;EAEA,aAAA;EACA,oBAAA;AAFF;;AAKA;EACE,UAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AAFF;;AAKA;EACE,UAAA;EACA,cAAA;EACA,aAAA;EAEA,gBAAA;EACA,aAAA;AAHF;;AAMA;EACE,UAAA;EACA,cAAA;EACA,aAAA;EAEA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAJF;;AAOA;EACE,0BAAA;EACA,aAAA;EACA,iBAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAJF;;AAOA;EACE,0BAAA;EACA,yBAAA;AAJF;;AAOA;EACE,uBAAA;AAJF;;AAOA;EAEE,aAAA;EACA,YAAA;EACA,eAAA;EAEA,YAAA;AANF;;AASA;EACE,yBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AANF;;AASA;EACE,0BAAA;EACA,aAAA;AANF;;AAUA;EACE,yBAAA;EACA,YAAA;AAPF;;AAUA;EACE,gBAAA;EACA,SAAA;EACA,aAAA;AAPF;;AAUA;EACE,aAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,0BAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;AAPF;;AAUA;;EAEE,yBAAA;EACA,WAAA;AAPF;;AAUA;EACE,yBAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;AAPF;;AAUA;EACE,yBAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,yBAAA;EACA,cAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;AAPF;;AAUA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;AAPF;;AAUA;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAPF;;AAYA;EACE;IACE,YAAA;EATF;;EAYA;IACE,eAAA;EATF;AACF;AAYA;EACE;IACE,eAAA;EAVF;AACF","sourcesContent":[".grid-formbuilder {\n  display: grid;\n  grid-template-columns: 1fr 5fr;\n  height: 100vh;\n}\n\n.left-sidebar {\n  // background-color: var(--primary);\n  text-align: center;\n  // padding: 15px;\n  height: 100vh;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.middle-sidebar {\n  overflow: hidden;\n  overflow-y: auto;\n  // height: 100vh;\n  padding: 25px;\n  padding-bottom: 35px;\n}\n\n.form-container {\n  width: 90%;\n  margin: 0 auto;\n}\n\n.right-sidebar {\n  background-color: rgb(212, 212, 212);\n  height: 100vh;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.type-box {\n  border: solid 2px black;\n  border-radius: 10px;\n  padding: 10px;\n  margin: 10px;\n  cursor: pointer;\n  background-color: grey;\n  color: white;\n}\n\n.main-container {\n  width: 70%;\n  margin: 0 auto;\n  height: 100vh;\n  // border: solid 2px black;\n  margin-top: 20px;\n  padding: 40px;\n}\n\n.schema-container {\n  width: 80%;\n  margin: 0 auto;\n  height: 100vh;\n  // border: solid 2px black;\n  overflow: hidden;\n  overflow-y: auto;\n  margin-top: 40px;\n  padding: 20px;\n}\n\n.drop-zone {\n  border: 2px dotted rgb(176, 176, 176);\n  padding: 10px;\n  min-height: 200px;\n}\n\n.drop-zone.withfield {\n  border: none;\n}\n\n.drop-zone-text {\n  position: absolute;\n  font-size: 20px;\n  font-weight: 600;\n  color: rgb(176, 176, 176);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.drag-over {\n  border: 2px dotted rgb(176, 176, 176);\n  background-color: rgb(223, 223, 223);\n}\n\n.drag-zone {\n  height: 100% !important;\n}\n\n.droppable-list {\n  // border: 2px solid rgb(176, 176, 176);\n  padding: 10px;\n  margin: 10px;\n  cursor: pointer;\n  // background-color: grey;\n  color: black;\n}\n\n.draggable-list-item {\n  border: 2px solid rgb(176, 176, 176);\n  padding: 10px;\n  margin: 10px;\n  cursor: pointer;\n  background-color: grey;\n  color: white;\n}\n\n.layout-drop-zone {\n  border: 2px dotted rgb(176, 176, 176);\n  padding: 10px;\n  // min-height: 200px;\n}\n\n.fb-sidebar {\n  background-color: #fcfcfd;\n  width: 250px;\n}\n\n.sticky-sidebar {\n  position: sticky;\n  top: 70px;\n  z-index: 1000;\n}\n\n.simplebar-content {\n  height: 100vh;\n}\n\n.form-name:disabled {\n  background-color: #fff;\n}\n\n.fb-btn {\n  background-color: #fff;\n  color: #344054;\n  border: 1px solid lightgray;\n  padding: 8px 15px 8px 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);\n  font-weight: 500;\n}\n\n.fb-btn:hover,\n.fb-btn:active {\n  background-color: #0a56ae;\n  color: #fff;\n}\n\n.fb-save-btn {\n  background-color: #12a35d;\n  color: #fff;\n  padding: 8px 15px 8px 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);\n  font-weight: 500;\n}\n\n.fb-delete-btn {\n  background-color: #d90909;\n  color: #fff;\n  padding: 8px 15px 8px 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.027);\n  font-weight: 500;\n}\n\n.fb-delete-btn:hover {\n  background-color: #fff;\n  border: 1px solid #d90909;\n  color: #d90909;\n}\n\n.form-info-label{\n  font-weight: 300;\n}\n\n.empty-dnd-box {\n  position: absolute;\n  top: 80px;\n  left: 30%;\n}\n\n.dnd-text {\n  font-weight: 100;\n  font-size: 15px;\n  text-align: center;\n}\n\n.dnd-box {\n  border-width: 1px;\n  border-style: dashed;\n  border-color: #b0b0b0;\n  border-radius: 8px;\n  padding: 5px;\n  min-height: 200px;\n}\n\n\n// Laptop\n@media (min-width: 1024px) {\n  .simplebar-content {\n    height: 85vh;\n  }\n\n  .form-info-label {\n    font-size: 11px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .form-info-label {\n    font-size: 13px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
